import { Text } from '@ui-component-library';
import TreebulaLogo from '@assets/treebula/logo.svg';

export default function UnderConstruction() {
    return <>
        <div className='flex justify-center items-center h-dvh px-4'>
            <div className='text-center' style={{maxWidth: '500px'}}>
                <div className='flex justify-center mb-12'>
                    <TreebulaLogo width='200px' />
                </div>

                <Text variant='bodyMediumBaseRegular' className='font-bold'>Sidan är under underhåll, Vi är strax tillbaka!</Text>

                <div className='flex justify-center'>
                    <img style={{width: "150px", height: "150px"}} src={Window.static_path+"img/icons/cog.svg"} />
                </div>

                <Text variant='bodySmallRegular' className='mb-4'>Vi genomför just nu planerat underhåll på vår webbplats för att förbättra prestanda och användarupplevelse. Vi ber om ursäkt för eventuella besvär detta medför.</Text>

                <Text variant='bodyMediumBaseRegular' className='mb-4'>Tack för ditt tålamod.</Text>

                <Text variant='bodyMediumBaseRegular'>Behöver du akut hjälp under tiden? Vänligen kontakta oss <a href='https://virkesborsen.typeform.com/to/DPp5jv1e' class='font-bold'>här</a>.</Text>
            </div>
        </div>
    </>
}